import axios from "axios";
import { normalizeString } from "../utils/sting.utils";
import { API_BASE_URL } from "./settings.api";

export interface Distance {
    text: string;
    value: number;
}

export interface NameValue {
    name: string;
    value: number;
}

export interface DistanceInterface {
    destination: string;
    distance: Distance;
    price: number;
    pricePerKM: NameValue;
    freeKM: NameValue;
}

export const getDistancePrice = async (place: string): Promise<DistanceInterface> => {
    try {
        const response = await axios.get(`${API_BASE_URL}/distance/${normalizeString(place)}`);
        return response.data;
    } catch (err) {
        console.log(err);
        return null;
    }
}

export const getPlaces = async (query: string): Promise<string[]> => {
    try {
        const response = await axios.get(`${API_BASE_URL}/distance/autocomplete/${normalizeString(query)}`);
        return response.data;
    } catch (err) {
        console.log(err);
        return [];
    }
}